import Swiper from "swiper";
import { Navigation } from 'swiper/modules'

// ! rename the function to align with the widget name
export const councillorCarousel = () => {
    const els = document.querySelectorAll('.curious-councillor-carousel');
    if (!els) return;

    // ------------------------------------------------------------

    els.forEach(carousel => {
        const swiper = carousel.querySelector('.councillor-swiper');
        const prev = carousel.querySelector('.prev');
        const next = carousel.querySelector('.next');
        const s = new Swiper(swiper, {
            modules: [Navigation],
            direction: 'horizontal',
            slidesPerView: 'auto',
            // spaceBetween: 16,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });

    });

    // ------------------------------------------------------------
    // ! Remember to call this function in the main script file: /site/src/js/site.js

}

